import React from "react"
import PropTypes from "prop-types"
import Radium from "higher-order-components/configured-radium/"
import COLOR_PALETTE from "constants/color-palette"
import { Interactive } from "AtomicComponents";

const Pencil = props => (
  <svg viewBox="0 0 14 14" {...props}>
    <path d="M10.39,6l0.9,0.9L6.22,11.91,0,14,2.1,7.79,7.15,2.73,8,3.62,3.2,8.47,2.32,11.08l0.6,0.59,2.61-.88ZM4,9.4A0.63,0.63,0,0,1,4.16,9L8.77,4.34l0.9,0.9L5.05,9.85A0.63,0.63,0,0,1,4.6,10,0.65,0.65,0,0,1,4,9.4Zm10-6a1.66,1.66,0,0,1-.48,1.16L12,6.13,7.88,2,9.4,0.48a1.65,1.65,0,0,1,2.33,0l1.8,1.79A1.66,1.66,0,0,1,14,3.45Zm-1.27,0a0.37,0.37,0,0,0-.1-0.27l-1.8-1.8a0.38,0.38,0,0,0-.54,0L9.67,2,12,4.34l0.63-.63A0.35,0.35,0,0,0,12.73,3.45Z" />
  </svg>
)

const SummaryItem = ({
  border,
  label,
  value,
  editText,
  onClick
}) => {
  return (
    <div
      style={[
        styles.base,
        border && { borderTop: "1px solid #ddd", paddingTop: "1.5em", marginTop: "1.5em" }
      ]}
      data-test="summary-item">
      <Interactive>{label}</Interactive>
      <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 200 }}>
        {value}
      </div>
      {onClick && (
        <span onClick={onClick} style={styles.editButton}>
          <Pencil
            style={styles.svg}
            data-test={`summary-item-step-${label}`} />
          {editText && <span style={styles.editText}>{editText}</span>}
        </span>
      )}
    </div>
  )
}

SummaryItem.propTypes = {
  border: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.node,
  editText: PropTypes.string,
  onClick: PropTypes.func
}

export default Radium(SummaryItem)

const styles = {
  base: {
    textAlign: "left",
    position: "relative",
    paddingTop: "1em"
  },
  label: {
    color: COLOR_PALETTE.GRAY_DARK,
    textTransform: "uppercase",
    fontSize: "80%",
    margin: "0 0 1em",
    display: "block",
    fontWeight: "600",
    letterSpacing: ".2em"
  },
  editText: {
    fontSize: "90%",
    color: COLOR_PALETTE.GRAY_DARK,
    marginLeft: "0.5em",
    marginBottom: "-0.2em"
  },
  editButton: {
    position: "absolute",
    top: "1em",
    right: 0,
    cursor: "pointer",
    transition: ".25s",
    color: COLOR_PALETTE.RED,
    display: "flex",
    alignItems: "center",
    ":hover": {
      color: COLOR_PALETTE.BLACK
    }
  },
  svg: {
    height: "1em",
    width: "1em",
    fill: "currentColor"
  }
}



// WEBPACK FOOTER //
// ./src/components/summary/item.jsx